<template>
  <sidebar-item-header class="pc-note__outline-header" :name="name">笔记大纲</sidebar-item-header>
</template>

<script>
import SidebarItemHeader from '@/components/note/sidebar/SidebarItemHeader.vue'

export default {
  components: {
    SidebarItemHeader
  },
  data () {
    return {
      name: 'outline'
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/variables.scss';
.pc-note__sidebar.note {
  .pc-note__outline-header {
    top: 0;
  }
}
.pc-note__sidebar.notebook {
  .pc-note__outline-header {
    top: 2.6rem;
    bottom: 8rem;
  }
}
</style>
